import { useTranslation } from '../i18n/LanguageContext'
import { useMobile } from '../hooks/useMobile'
import TermsContent from './TermsContent'

interface TermsPageProps {
  onBack: () => void
}

export default function TermsPage({ onBack }: TermsPageProps) {
  const { t } = useTranslation()
  const isMobile = useMobile()
  const tc = t.terms

  return (
    <div style={s.root}>
      <div style={{ ...s.container, ...(isMobile ? sm.container : {}) }}>
        <button onClick={onBack} style={s.backBtn} aria-label={tc.backBtn}>
          ← {tc.backBtn}
        </button>
        <h1 style={{ ...s.title, ...(isMobile ? sm.title : {}) }}>{tc.title}</h1>
        <TermsContent />
      </div>
    </div>
  )
}

const s: Record<string, React.CSSProperties> = {
  root: {
    minHeight:      '100vh',
    background:     '#FAF6EF',
    display:        'flex',
    justifyContent: 'center',
    padding:        '2rem 1rem 4rem',
  },
  container: {
    maxWidth: 640,
    width:    '100%',
  },
  backBtn: {
    background:   'none',
    border:       'none',
    cursor:       'pointer',
    color:        '#2D6A4F',
    fontSize:     '1rem',
    fontWeight:   600,
    padding:      '0.5rem 0',
    marginBottom: '1.5rem',
    minHeight:    48,
  },
  title: {
    fontSize:     '1.75rem',
    fontWeight:   700,
    color:        '#1B4332',
    marginBottom: '0.5rem',
  },
}

const sm: Record<string, React.CSSProperties> = {
  container: { maxWidth: '100%' },
  title:     { fontSize: '1.5rem' },
}
